const { DefaultEventTypes } = require('./default');

const SIGNUP_TAG = 'signup';

const SignupEvents = {
  ATTEMPTED: `${SIGNUP_TAG}.${DefaultEventTypes.ATTEMPTED}`,
  SUCCESS: `${SIGNUP_TAG}.${DefaultEventTypes.SUCCESS}`,
  FAILED: `${SIGNUP_TAG}.${DefaultEventTypes.FAILED}`,
  UNKNOWN_FAILURE: `${SIGNUP_TAG}.${DefaultEventTypes.UNKNOWN_FAILURE}`,
  VERIFICATION_EMAIL_SENT: `${SIGNUP_TAG}.verification_email_sent`,
  VERIFICATION_EMAIL_SEND_FAIL: `${SIGNUP_TAG}.verification_send_failed`,
};

module.exports = { SIGNUP_TAG, SignupEvents };
